module.exports = __webpack_public_path__ + "assets/img/26_876_big.1dde8411.jpg";